import { FC, useEffect, useState } from "react";
import { Header } from "../parts/Header";
import { fetchAsync, fetchWithoutSignAsync } from "../ApiHandler";
import { BoardItem, BoardResponse } from "../Model/BoardItem";
import { unescape } from "querystring";
import { ToDateString } from "../utils/DateUtil";
import { getDayOfWeekString } from "../utils/DateUtil";
import { TrimSeconds } from "../utils/DateUtil";
import { recruitmentAnnouncement } from "../constants/recruitment";

export const TopPage: FC = () => {
  const [list, setList] = useState(undefined as BoardItem[] | undefined);

  useEffect(() => {
    const fetchList = async () => {
      const list = await fetchWithoutSignAsync<BoardItem[]>('TrainingDay/GetListForVisitor', null);
      setList(list);
    };
    fetchList();
  }, []);

  return <div>
    <Header></Header>
    <div>
      <img src="/images/top-02.jpg" style={{ width: '100%' }}></img>
    </div>

    <div className="margin-auto px-4 box-border" style={{ width: '720px', maxWidth: '100%' }}>
      <h1 className="font-bold mt-12">世田谷バドミントンクラブ CHIROL (チロル)</h1>
      <div className="px-3 py-2 mt-4 mb-4" style={{ whiteSpace: 'pre-line', fontSize: '14px', border: '1px solid rgb(33, 150, 243)', borderRadius: '4px', color: 'rgb(33, 150, 243)' }}>
        {recruitmentAnnouncement}
      </div>
      <div className="mb-8">
        <div className="margin-auto" style={{ maxWidth: '360px' }}>
          <a
            href="/join"
            className="hover-button"
            style={{
              display: 'block',
              textDecoration: 'none',
              textAlign: 'center',
              padding: '12px 20px',
              borderRadius: '8px',
              border: '1px solid #cbd5e1',
              backgroundColor: '#f1f5f9',
              color: '#334155',
              fontWeight: 600,
              boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
            }}
            aria-label="初参加はこちらから"
          >
            初参加はこちらから
          </a>
        </div>
      </div>
      <div className="mt-12 mb-12">
        <div className="sub-title">直近の練習日程</div>
        { list && list!.map((e) => (
          <div>
             {ToDateString(e.trainingDay?.date!)} ({getDayOfWeekString(e.trainingDay?.date!)}) {TrimSeconds(e.trainingDay?.startTime!)} - {TrimSeconds(e.trainingDay?.endTime!)} {e.trainingPlace?.areaName}
          </div>
        ))}
      </div>
      <div className="mb-12">
        <div className="sub-title">活動内容</div>
        <div>2004年から東京都世田谷区で活動している社会人バドミントンサークルです。</div>
      </div>
      <div className="mb-12">
        <div className="sub-title">メンバー</div>
        <div>
          20代・30代の社会人の方が中心です。<br/>
          男性と女性の比率は 3:1 ほどです。<br/>
          サークル全体の人数は約40名。毎回15名前後で練習しています。
        </div>
      </div>
      <div className="mb-12">
        <div className="sub-title">練習日時・場所</div>
        <div>
        土曜日・日曜日・祝日に、世田谷区の小・中学校の体育館で練習をしています。<br/>
        <br></br>
        上北沢、三軒茶屋、笹塚、祖師ヶ谷大蔵など、京王線・小田急線・世田谷線沿いで練習することが多いです。<br/>
        </div>
      </div>

      <div className="mb-12">
        <div className="sub-title">練習について</div>
        <div>
          練習の前半は、ランダムに組み合わせを指定してダブルス。後半は組み合わせ自由でダブルスです。<br/>
          <br/>
          コートが空いていれば、各自でサービスや基礎打ちなどの練習ができます。<br/>
          大会が近いメンバーは、ペア固定の試合・シングル戦も調整できます。<br/>
        </div>
      </div>

      <div className="mb-12">
        <div className="sub-title">持参するもの</div>
        <div>
        ・ラケット<br/>
        ・バドミントン用のシューズ<br/>
        ・ウェア<br/>
        ・飲み物<br/>
        </div>
      </div>

      <div className="mb-12">
        <div className="sub-title">参加費</div>
        <div>
        4時間練習: 1200円<br/>
        2時間半練習: 1000円<br/>
        <br/>
        コートが2,3面の体育館で、練習1回あたりの参加費です。入会費・年会費はありません。<br/>
        <br/>
        キャッシュレス推進のため、現金支払いは不可です。参加費はPayPayで送金してください。<br/>
        送金するためには、事前にPayPayで本人確認を済ませておく必要があります。<br/>
        PayPayの送金ができない場合、できるメンバーに現金を渡して、そのメンバー経由で送金してもらいます。<br/>
        <br/>
        着替え、準備の前までに参加費を送金して頂きます。<br/>
        </div>
      </div>

    </div>
  </div>
}
